(function () {
  if (window.__smtOptionsInit) return;
  window.__smtOptionsInit = true;

  var money = function (cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var plus = function (dollars) { return dollars > 0 ? ' (+' + money(Math.round(dollars * 100)) + ')' : ''; };
  var isHeader = function (v) { return /^\s*-{2,}.*-{2,}\s*$/.test(v); };
  var esc = function (s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); };

  function init(root) {
    if (root.__smt) return;
    root.__smt = true;
    var cfg = JSON.parse(root.querySelector('[data-smt-config]').textContent || '{}');
    var addons = JSON.parse(root.querySelector('[data-smt-addons]').textContent || '{"rear":{},"abs":{}}');
    var variants = JSON.parse(root.querySelector('[data-smt-variants]').textContent || '{}');
    var formId = root.getAttribute('data-form-id');
    var form = document.getElementById(formId) || root.closest('form');
    if (!form) return;
    var fid = form.getAttribute('id');
    var fields = root.querySelector('[data-smt-fields]');
    var totalEl = root.querySelector('[data-smt-total]');
    var errEl = root.querySelector('[data-smt-error]');
    var title = root.getAttribute('data-product-title');

    function field(name, required, inner) {
      var w = document.createElement('div');
      w.className = 'smt-options__field';
      w.innerHTML = '<label>' + esc(name) + (required ? '<span class="req">*</span>' : '') + '</label>' + inner;
      fields.appendChild(w);
      return w;
    }
    function selectHtml(prop, opts, placeholder) {
      var h = '<select name="properties[' + esc(prop) + ']" form="' + esc(fid) + '">';
      if (placeholder) h += '<option value="">' + esc(placeholder) + '</option>';
      opts.forEach(function (o) {
        if (isHeader(o.l)) h += '<option disabled>' + esc(o.l.replace(/-/g, '').trim()) + '</option>';
        else h += '<option value="' + esc(o.l) + '" data-add="' + (o.a || 0) + '">' + esc(o.l) + plus(o.a || 0) + '</option>';
      });
      return h + '</select>';
    }

    var rearSel = null, absSel = null, absWrap = null;
    if (cfg.rear && cfg.rear.options && cfg.rear.options.length) {
      var rw = field(cfg.rear.name, true, selectHtml(cfg.rear.name, cfg.rear.options));
      rearSel = rw.querySelector('select');
    }
    function rearIsNone() {
      if (!rearSel) return true;
      var o = cfg.rear.options[rearSel.selectedIndex];
      return !o || o.none;
    }
    function absList() {
      if (!cfg.abs) return [];
      var l = rearIsNone() ? cfg.abs.norear : cfg.abs.rear;
      return (l && l.length) ? l : (cfg.abs.norear || cfg.abs.rear || []);
    }
    function renderAbs() {
      if (!cfg.abs) return;
      var keep = absSel ? absSel.value : null;
      var list = absList();
      if (!list.length) return;
      if (!absWrap) { absWrap = field(cfg.abs.name, true, ''); }
      absWrap.innerHTML = '<label>' + esc(cfg.abs.name) + '<span class="req">*</span></label>' + selectHtml(cfg.abs.name, list);
      absSel = absWrap.querySelector('select');
      if (keep) { for (var i = 0; i < absSel.options.length; i++) if (absSel.options[i].value === keep) absSel.selectedIndex = i; }
      absSel.addEventListener('change', update);
    }
    renderAbs();
    if (rearSel) rearSel.addEventListener('change', function () { renderAbs(); update(); });

    var extraSels = [];
    (cfg.extras || []).forEach(function (e) {
      if (e.type === 'text') {
        var t = field(e.name, e.required, '<textarea name="properties[' + esc(e.name) + ']" form="' + esc(fid) + '"></textarea>');
        extraSels.push({ el: t.querySelector('textarea'), wrap: t, e: e });
      } else {
        var opts = (e.values || []).map(function (v) { return { l: v, a: (e.adds && e.adds[v]) || 0 }; });
        var w = field(e.name, e.required, selectHtml(e.name, opts, e.required ? 'Choose ' + e.name.toLowerCase() : 'Choose (optional)'));
        var s = w.querySelector('select');
        s.addEventListener('change', update);
        extraSels.push({ el: s, wrap: w, e: e });
      }
    });

    function addOf(sel) {
      if (!sel || sel.selectedIndex < 0) return 0;
      var o = sel.options[sel.selectedIndex];
      return parseFloat(o.getAttribute('data-add') || '0') || 0;
    }
    function currentVariant() {
      var i = form.querySelector('[name="id"]');
      return i ? variants[i.value] : null;
    }
    function qty() {
      var q = form.querySelector('[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    }
    function update() {
      var v = currentVariant();
      var cents = v ? v.p : 0;
      cents += Math.round(addOf(rearSel) * 100) + Math.round(addOf(absSel) * 100);
      extraSels.forEach(function (x) { if (x.el.tagName === 'SELECT') cents += Math.round(addOf(x.el) * 100); });
      totalEl.textContent = money(cents);
    }
    var lastId = null;
    setInterval(function () {
      var i = form.querySelector('[name="id"]');
      if (i && i.value !== lastId) { lastId = i.value; update(); }
    }, 400);
    update();

    form.addEventListener('submit', function (evt) {
      if (form.dataset.smtReady === '1') { form.dataset.smtReady = ''; return; }
      evt.preventDefault();
      evt.stopImmediatePropagation();
      errEl.hidden = true;
      var missing = null;
      extraSels.forEach(function (x) {
        x.wrap.classList.remove('is-invalid');
        if (x.e.required && !String(x.el.value || '').trim()) { x.wrap.classList.add('is-invalid'); if (!missing) missing = x; }
      });
      if (missing) {
        errEl.textContent = 'Please choose your ' + missing.e.name.toLowerCase() + ' so we build the right fitment.';
        errEl.hidden = false;
        missing.el.focus();
        return;
      }
      var v = currentVariant();
      var forLabel = title + (v && v.t && v.t !== 'Default Title' ? ' – ' + v.t : '');
      var items = [];
      function push(map, dollars, kind, label) {
        if (!(dollars > 0)) return true;
        var key = String(Math.round(dollars * 100));
        var id = map[key];
        if (!id) return false;
        var props = { 'For': forLabel };
        props[kind] = label;
        items.push({ id: id, quantity: qty(), properties: props });
        return true;
      }
      var ok = true;
      if (rearSel) ok = push(addons.rear, addOf(rearSel), cfg.rear.name, rearSel.value) && ok;
      if (absSel) ok = push(addons.abs, addOf(absSel), cfg.abs.name, absSel.value) && ok;
      extraSels.forEach(function (x) { if (x.el.tagName === 'SELECT') ok = push(addons.abs, addOf(x.el), x.e.name, x.el.value) && ok; });
      if (!ok) {
        errEl.textContent = 'This combination needs a quick price check. Please call Audio Hoggz at 832-370-0028.';
        errEl.hidden = false;
        return;
      }
      var go = function () {
        form.dataset.smtReady = '1';
        var btn = form.querySelector('[name="add"]');
        if (form.requestSubmit) form.requestSubmit(btn || undefined); else form.submit();
      };
      if (!items.length) { go(); return; }
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add-ons');
        go();
      }).catch(function () {
        errEl.textContent = 'Sorry, we could not add your options. Please try again or call 832-370-0028.';
        errEl.hidden = false;
      });
    }, true);
  }

  function boot() { document.querySelectorAll('[data-smt-options]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true });
})();
